import React from 'react';
import { AutoComplete, Input } from 'antd';
import { Search } from 'lucide-react';

/** Search box above the segments table (filtering lives in the screen controller). */
function SegmentTableActions({ search, suggestions = [], onSearch, onSearchChange }) {
    return (
        <AutoComplete
            value={search}
            options={suggestions.map((value) => ({ value }))}
            onSearch={onSearch}
            onSelect={onSearch}
            onChange={(value) => onSearchChange(value)}
            className="w-full sm:w-80">
            <Input
                aria-label="Buscar"
                placeholder="Buscar segmentación..."
                prefix={<Search className="text-surface-400" />}
                allowClear
            />
        </AutoComplete>
    );
}

export default SegmentTableActions;
